import Event from '@oppobrowser/lib-browser-event';
import wv from '@cpc/lib-browser-jsapi';
import { $, asyncLoadJs } from '@js/utils';
import { pubArticleInfo } from '../../js/auxiliary';

const EventHandler = {};

export default class Comment {
  constructor(el, name, data = {}) {
    this.el = el;

    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    pubArticleInfo();

  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  async render() {
    const {
      docInfo,
      commentEnv,
      title,
      url,
      pageType,
      styleType,
      fromId,
      commentStatus,
      publishTime,
      keywords,
      replyPageUrl,
      commentMoreUrl,
      media,
      sourceVal,
      sourceEn,
      sourceCode,
      nightMode,
    } = window.store;

    const sdkObj = window.pageData.commentSdkLink;
    let jsLink = sourceVal == 'tencent' ? sdkObj.tencent : sdkObj.oppo;
    jsLink = jsLink
      ? jsLink
      : '//static-cpc.heytapimage.com/comment-sdk-prod/feeds/comment-sdk-combine@latest.js';
    const tasks = [asyncLoadJs(jsLink)];

    Promise.all(tasks)
      .then(() => {
        window.commentSdk
          .create({
            env: commentEnv,
            systemId: 'feeds',
            el: $('#feeds_comment'),
            docId: docInfo.resourceId,
            resourceId: docInfo.resourceId,
            source: docInfo.source,
            debugMode: commentEnv !== 'production',
            pageType:
              pageType === 'second-comment'
                ? 2
                : pageType === 'comment'
                ? 1
                : 0,
            commentStatus,
            isNightMode: nightMode,
            documentMeta: {
              dataSource: sourceVal,
              sourceEn,
              sourceCode,
              mediaName: media.name,
              mediaId: media.id,
              title,
              url,
              staticId: '',
              styleType,
              supportReport: wv.isSupportReplyReport(),
              channelId: '',
              fromId,
              publishTime,
              keywords,
              replyPageUrl,
              commentMoreUrl,
            },

            adConfig: window.pageData.commentAdConfig || {},
          })
          .render();
      })
      .catch((error) => {
        console.error(error);
        pubArticleInfo();
      });
  }
}
